import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  & > div {
    width: 100%;
  }
  table {
    width: 100%;
    .theadTr {
      border-bottom: none;
    }
    thead tr td,
    thead th {
      height: 50px;
    }
  }
`;
